@use "styles" as *;
@use "sass:map";

$block: me-table;

.#{$block} {
  display: block;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: space(2);
  }

  thead td, thead th {
    &:first-child {
      border-top-left-radius: $border-radius;
    }

    &:last-child {
      border-top-right-radius: $border-radius;
    }
  }

  tfoot td, tfoot th {
    &:first-child {
      border-bottom-left-radius:$border-radius;
    }

    &:last-child {
      border-bottom-right-radius:$border-radius;
    }
  }

  tfoot td:empty {
    height: space(9);
  }

  tbody tr {
    background-color: $color-background;
  }

  &--striped {
    tbody {
      tr:nth-child(odd) {
        background-color: $color-background;
      }

      tr:nth-child(even) {
        background-color: $color-gray-100;
      }
    }
  }

  @each $theme, $theme-options in $table-themes {
    &--#{$theme} {
      thead th, thead td, tfoot th, tfoot td, .me-link {
        background-color: map.get($theme-options, background-color);
        color: map.get($theme-options, color);
        font-weight: map.get($theme-options, font-weight);
      }
    }
  }
}

.me-tabs--foldernav .me-tabs__body .#{$block} {
  thead td, thead th {
    &:first-child, &:last-child {
      border-radius: unset;
    }
  }
}
